import {observable, computed, action, observe} from 'mobx';

import {generateResponseID} from './../utils/Utils';
import ElementStore from './ElementStore';
import QuestionStore from './QuestionStore';
import L from "leaflet";

export default class AppStore {
    constructor() {
        this.elementStore = new ElementStore(this);
        this.questionStore = new QuestionStore(this);

        // Auto close drawer on IconButton press when using mobile
        observe(this.pendingState, (change) => {
            if (change.newValue !== null && this.isMobile) {
                this.drawer.open = false;
            }
        });

        if (window.location.hash.indexOf("response_id") > -1) {
            this.responseID = window.location.hash.split('response_id=')[1]
        } else {
            this.responseID = generateResponseID();
        }
    }

    loadConfig(json) {
        this.appConfig = json;
        this.environment = this.appConfig.environment;
        this.branchDisplayName = this.appConfig.branchDisplayName;

        this.loadMap(json.map);
        this.loadSurvey(json.survey);
        this.loadQuestions(json.questions);
        this.loadContent(json.content);
    }

    loadContent(json) {
        this.content = json;
    }

    loadQuestions(json) {
        this.questionStore.importQuestions(json);
    }

    loadSurvey(json) {
        this.surveyConfig = json;
    }

    loadMap(json) {
        this.map.viewport = json.initView;
        this.map.zoom = json.zoom;
        this.map.layerIds = json.layerIds;
    }

    getMapZooms() {
        return {minZoom: this.appConfig.map.zoom.min, maxZoom: this.appConfig.map.zoom.max};
    }



    appConfig = null;
    surveyConfig = null;
    environment = null;
    branchDisplayName = null;
    responseID = null;

    @observable map = {
        viewport: {
            center: {
                lat: 42,
                lng: -71
            },
            zoom: 13
        },
        mode: 'RoadMap',
        layerIds: null,
        element: null,
        editLayer: null
    };

    @observable content = {
        brand: {
            logo: "",
            brandColor: {
                r: 10,
                g: 10,
                b: 10,
                a: 1
            }
        },
        introduction: {
            headline: "",
            text: "",
            dataUsage: "",
            instructions: ""
        },
        thankyou: {
            headline: "",
            text: "",
            label: "",
            link: ""
        },
        demographics: {
            headline: "",
            description: ""
        }
    };

    @observable drawer = {
        active: 'icon',
        open: true,
        expanded: false,
        disabled: false
    };

    @observable isMBIconClicked = false;

    @action toggleMBIconClick() {
        this.isMBIconClicked = !this.isMBIconClicked;
    }

    @observable addMoreButtons = false;

    @action setMoreButtons(setVal) {
        console.log('here..');
        this.addMoreButtons = setVal;
    }

    @observable pendingState = {
        element: null,
        popup: false,
        editing: false,
        savePopup: false,
        confirmationPopup: false,
    };

    @observable isMobile = false;
    @observable introModal = true;

    @action setSavePopup(val) {
        this.pendingState.savePopup = val;
    }

    @action setConfirmationPopup(val) {
        this.pendingState.confirmationPopup = val;
    }

    @action setIntroModal(val) {
        this.introModal = val;
    }

    @action setPendingElementPosition(val) {
        this.pendingState.element.position = val;
    }

    @action setPendingElementReaction(val) {
        this.pendingState.element.reaction = val;
    }

    @action setPendingElementText(val) {
        this.pendingState.element.text = val;
    }

    @action setPendingStateEditing(val) {
        this.pendingState.editing = val;
    }

    @action setMapViewport(val) {
        this.map.viewport = val;
    }

    @action toggleMapMode() {
        this.map.mode = (this.map.mode === 'Satellite') ? 'RoadMap' : 'Satellite';
    }

    @action setIsMobile(val) {
        this.isMobile = val;
    }

    @action setDrawer(drawer) {
        Object.keys(drawer).forEach((k) => {
            this.drawer[k] = drawer[k];
        });
    }

    @action disableDrawer(val) {
        this.drawer.disabled = val;
    }

    @computed get editMode() {
        return (this.pendingState.element !== null);
    }

    @computed get placingIconMode() {
        return this.editMode && !this.pendingState.savePopup;
    }

    @computed get allowSave() {
        if (this.pendingState.element){
            if (this.pendingState.element.icon.type === "icon"){
                return !!this.pendingState.element.position;
            } else if (this.pendingState.element.icon.type === "polyline") {
                return !!this.pendingState.element.position[1];
            } else if (this.pendingState.element.icon.type === "polygon") {
                return !!this.pendingState.element.position[2];
            }
        } else {
            return false;
        }
    }

    @action configureElement(element) {
        this.map.element = element;
        if (this.map.element) {
            this.map.element.options.closePopupOnClick = false;
            this.map.element.options.viewport = this.map.viewport;//CODE-REVIEW:RAJ:we shouldn't be setting for elements inidividually here, can this be centralized?
            this.map.editLayer = new L.LayerGroup();
            this.map.element.editTools.editLayer = this.map.editLayer;
            this.map.editLayer.addTo(this.map.element);
        }
    }

    @action clearPending = () => {
        this.pendingState.popup = false;
        this.pendingState.element = null;
        this.pendingState.editing = false;
        this.pendingState.savePopup = false;
        this.pendingState.confirmationPopup = false;
        this.drawer.disabled = false;
    }
}



// WEBPACK FOOTER //
// ./src/stores/AppStore.js